import { ImageFormat } from '@util/assets'

/**
 * Preferred image format for each avatar size. This helps reduce the blurriness especially in small sizes.
 */
export const preferredAvatarSizeFormat: {
    [key in 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge']: ImageFormat
} = {
    xsmall: '24_24-3x', // 24x24
    small: '32_32-3x', // 32x32
    medium: '48_48-3x', // 40x40
    large: '64_64-3x', // 56x56
    xlarge: '80_80-3x', // 88x88
}
